<template>
  <div class="armario-node">
    <!-- Fila del Nodo -->
    <div
      class="node-row d-flex align-center"
      :class="{ 'node-active': isSelected }"
      @click.stop="selectNode(node)"
    >
      <!-- Zona de la Flecha (Click para expandir/colapsar) -->
      <div 
        v-if="hasChildren" 
        class="expansion-wrapper d-flex align-center justify-center"
        @click.stop="toggleExpand"
      >
        <v-icon 
          small 
          class="expansion-icon"
          :class="{ 'rotated': node.expanded }"
        >
          mdi-chevron-right
        </v-icon>
      </div>
      
      <!-- Espaciador si no tiene hijos -->
      <div v-else class="mr-6"></div>

      <!-- Icono de Carpeta/Armario (Click también selecciona) -->
      <v-icon
        small
        :color="isSelected ? 'primary' : 'grey darken-1'"
        class="mr-2"
      >
        {{ hasChildren ? (node.expanded ? 'mdi-folder-open' : 'mdi-folder') : 'mdi-dresser-outline' }}
      </v-icon>

      <!-- Texto del Nodo -->
      <span class="node-text text-truncate" :title="node.name">
        {{ node && node.name ? node.name : 'Sin nombre' }}
      </span>
    </div>

    <!-- Contenedor de Hijos (Recursión) -->
    <v-expand-transition>
      <div v-if="hasChildren && node.expanded" class="node-children">
        <ArmariosLista
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          :selectedNode="selectedNode"
          @select="$emit('select', $event)"
          @toggle="$emit('toggle', $event)"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "ArmariosLista",
  props: {
    node: Object,
    selectedNode: Object
  },
  methods: {
    selectNode(node) {
      // Emitimos el evento de selección al padre
      this.$emit("select", node);
    },
    toggleExpand() {
      // Emitimos un evento toggle. 
      // En Vue 2, al ser objetos, modificar node.expanded funcionará 
      // pero lo correcto es que el padre lo gestione.
      this.$emit("toggle", this.node);
    }
  },
  computed: {
    isSelected() {
      return this.selectedNode && this.selectedNode.id === this.node.id;
    },
    hasChildren() {
      return this.node && this.node.children && this.node.children.length > 0;
    }
  }
};
</script>

<style scoped>
.armario-node {
  user-select: none;
  width: 100%;

}

.node-row {
  cursor: pointer;
  padding: 6px 8px; /* Un poco más de padding */
  border-radius: 4px;
  transition: background-color 0.2s ease;
  margin-bottom: 2px;
  font-size: 0.85rem;
  color: #444;
  position: relative;
  /* Permitir que la fila crezca si el texto salta de línea */
  height: auto !important; 
  min-height: 32px;
  align-items: flex-start; /* Alinea iconos arriba si hay varias líneas de texto */
}

.node-row:hover {
  background-color: rgba(25, 118, 210, 0.05);
}

/* Área de clic de la flecha ampliada para UX */
.expansion-wrapper {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 4px;
  flex-shrink: 0; /* Que no se encoja el icono */
  transition: background-color 0.2s;
}

.expansion-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.node-active {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
}

.node-active .node-text {
  font-weight: 600;
}

/* Indicador lateral para el nodo seleccionado */
.node-active::before {
  content: "";
  position: absolute;
  left: 0;
  width: 3px;
  height: 60%;
  background-color: #1976d2;
  border-radius: 0 4px 4px 0;
}

.node-children {
  padding-left: 12px;
  margin-left: 11px;
  border-left: 1px solid #e0e0e0;
}

.expansion-icon {
  transition: transform 0.2s ease;
}

.expansion-icon.rotated {
  transform: rotate(90deg);
}

.node-text {
  white-space: normal !important;    /* PERMITE SALTO DE LÍNEA */
  word-break: break-word !important; /* ROMPE PALABRAS LARGAS */
  overflow: visible !important;      /* MUESTRA TODO */
  text-overflow: clip !important;    /* QUITA LOS PUNTOS (...) */
  flex-grow: 1;
  line-height: 1.3 !important;
  display: inline-block;
  padding-top: 2px;
}
</style>